<template>
  <div>
    <div ref="form">
      <!-- Row Loop -->
      <b-row
        v-for="(figura, index) in TiposFigura"
        :id="index"
        :key="index"
        ref="row"
      >
        <!-- Item Name -->
        <b-col cols="10">
          <FiguraTransporte :figura="figura" :index="index" />
        </b-col>

        <!-- Remove Button -->
        <b-col cols="2">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-danger"
            class="mt-0 mt-md-2"
            @click="removeItem(index)"
          >
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Borrar</span>
          </b-button>
        </b-col>
        <b-col cols="12"> </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Agregar figura</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { mapActions } from 'vuex'
import { mapMultiRowFields } from 'vuex-map-fields'
import FiguraTransporte from '@/views/CartaPorte/FiguraTransporte'

export default {
  components: {
    FiguraTransporte,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      nextRowId: 0,
    }
  },
  computed: {
    ...mapMultiRowFields('CartaPorte', {
      TiposFigura:
        'objJson.complemento.CartaPorte.FiguraTransporte.TiposFigura',
    }),
  },
  mounted() {
    this.initTrHeight()
    this.nextRowId = this.TiposFigura.length
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    ...mapActions('CartaPorte', ['addFigura', 'deleteFigura']),
    addItem() {
      this.addFigura({
        TipoDeResidencia: { title: 'Nacional', valx: 'nacional' },
        '@TipoFigura': { title: 'Operador', value: '01' },
        '@RFCFigura': '',
        '@NumLicencia': '',
        '@NombreFigura': '',
        '@NumRegIdTribFigura': '',
        '@ResidenciaFiscalFigura': '',
        PartesTransporte: [],
        Domicilio: {
          '@Calle': '',
          '@NumeroExterior': '',
          '@NumeroInterior': '',
          '@Colonia': '',
          '@Localidad': '',
          '@Referencia': '',
          '@Municipio': '',
          '@Estado': '',
          '@Pais': '',
          '@CodigoPostal': '',
        },
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.deleteFigura(index)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select.scss';
</style>
